
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8G6ap", function(module, exports) {
/**
 * @generated SignedSource<<dd0556511b83cb3e3138676b33f70766>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $71fe66a34533a706$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "usePublishModalActionsSchedulePublishInfoFragment",
    "selections": [
        {
            "concreteType": "SchedulePublishInfo",
            "kind": "LinkedField",
            "name": "schedulePublishInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "date"
                },
                {
                    "kind": "ScalarField",
                    "name": "minorEdit"
                },
                {
                    "kind": "ScalarField",
                    "name": "targetType"
                },
                {
                    "kind": "ScalarField",
                    "name": "versionComment"
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ],
    "type": "Content"
};
$71fe66a34533a706$var$node.hash = "5dc641b473052bf1fb2921bbc4960dcc";
var $71fe66a34533a706$export$2e2bcd8739ae039 = $71fe66a34533a706$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dWCFT = parcelRequire("dWCFT");


var $3Vbz9 = parcelRequire("3Vbz9");


var $dPJCf = parcelRequire("dPJCf");


var $ep3mz = parcelRequire("ep3mz");


var $jlIaF = parcelRequire("jlIaF");


var $dF5uX = parcelRequire("dF5uX");


var $3Gp1y = parcelRequire("3Gp1y");


var $iVd6X = parcelRequire("iVd6X");


var $7Sm4c = parcelRequire("7Sm4c");


var $cHfGW = parcelRequire("cHfGW");


var $cQhbe = parcelRequire("cQhbe");


var $sLZsl = parcelRequire("sLZsl");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $ij4CE = parcelRequire("ij4CE");


var $bQm3c = parcelRequire("bQm3c");



// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $9xGvk = parcelRequire("9xGvk");




var $9wGTI = parcelRequire("9wGTI");


var $ibgjl = parcelRequire("ibgjl");


var $f5bZm = parcelRequire("f5bZm");


var $jVFPV = parcelRequire("jVFPV");










const $a52bc4dbc0ad9048$export$eaf875eaf4cf65ed = ({ flags: flags, attributes: attributes, customFlagMessage: customFlagMessage })=>{
    flags && flags.showErrorFlag({
        title: customFlagMessage && customFlagMessage.title ? customFlagMessage.title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $dF5uX.blogifyErrorMessage)(attributes?.error).title),
        description: customFlagMessage && customFlagMessage.description ? customFlagMessage.description : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $dF5uX.blogifyErrorMessage)(attributes?.error).description)
    });
};



const $16359ce789b5f49e$var$i18n = (0, $aXWIB.defineMessages)({
    scheduledPublishMessage: {
        id: "publish-modal.schedule.publish.message",
        defaultMessage: "{pageTitle} will be published on {date} at {time}"
    },
    scheduledUpdateMessage: {
        id: "publish-modal.schedule.update.message",
        defaultMessage: "{pageTitle} will be updated on {date} at {time}"
    },
    scheduledPublishTitle: {
        id: "publish-modal.schedule.publish.title",
        defaultMessage: "Publish scheduled"
    },
    scheduledUpdateTitle: {
        id: "publish-modal.schedule.update.title",
        defaultMessage: "Update scheduled"
    }
});
const $16359ce789b5f49e$export$d8d8a20fb72e9793 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f5bZm.usePublishModalAnalyticsEvent)();
    const convertPageToBlog = (0, $3Gp1y.useConvertPageToBlog)();
    const [isAutoConverted] = (0, $sLZsl.useAutoConvertState)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { versionComments: versionComments, publishAsBlog: publishAsBlog, shouldNotifyComputedValue: shouldNotifyComputedValue, scheduledPublishDate: scheduledPublishDate, onClickPublish: onClickPublish, onClickPreview: onClickPreview, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, flags: flags, hasModifiedSettings: hasModifiedSettings, moveParams: moveParams, gqlRestrictionsInput: gqlRestrictionsInput, hasModifiedRestrictions: hasModifiedRestrictions, isBlog: isBlog } = (0, $42omo.useContext)((0, $ibgjl.PublishModalContext));
    const closeMove = moveParams?.closeMove;
    const fragmentWriterInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $71fe66a34533a706$export$2e2bcd8739ae039),
        fragmentArtifact: (0, $71fe66a34533a706$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/publish-modal"
    });
    const handleRescheduleWithNoChanges = async (closeModal, isUnpublishedDraft)=>{
        if (scheduledPublishDate) {
            const monthDayRegex = /[^,]*$/g; // selects everything after comma ","
            const date = (0, $dWCFT.default)(scheduledPublishDate, 'PP').replace(monthDayRegex, ''); // Ex: Aug 29,
            const time = (0, $3Vbz9.format)(scheduledPublishDate, 'h:mm aaaa z'); // Ex: 11:00 a.m. PST
            const { title: pageTitle } = await retrieveEditorTitleAndContent();
            closeModal({
                endPublishExperience: true
            });
            flags.showInfoFlag({
                title: intl.formatMessage(isUnpublishedDraft ? $16359ce789b5f49e$var$i18n.scheduledPublishTitle : $16359ce789b5f49e$var$i18n.scheduledUpdateTitle),
                description: intl.formatMessage(isUnpublishedDraft ? $16359ce789b5f49e$var$i18n.scheduledPublishMessage : $16359ce789b5f49e$var$i18n.scheduledUpdateMessage, {
                    pageTitle: pageTitle,
                    date: date,
                    time: time
                })
            });
        }
    };
    const handlePublishWithoutConversion = ({ analyticsSource: analyticsSource, closeModal: closeModal, isUnpublishedDraft: isUnpublishedDraft, shouldNotifyOverride: shouldNotifyOverride })=>{
        // if page is already scheduled to be updated and no publish setting are changed,
        // we can just confirm the existing scheduled publish
        if (!hasModifiedSettings && !!scheduledPublishDate && closeModal) {
            handleRescheduleWithNoChanges(closeModal, isUnpublishedDraft);
            return;
        }
        // This makes the publish modal publish button switch to "Scheduled" right away after completing a schedule publish.
        // This is achieved by temporarily writing the new schedule publish date into the GraphQL cache.
        // Apollo will still re-query though to get the true result from the server, is case of failure.
        if (!!scheduledPublishDate && contentId) (0, $jVFPV.cacheSchedulePublishTime)({
            contentId: contentId,
            schedulePublishDate: scheduledPublishDate?.toISOString(),
            fragmentWriterInterop: fragmentWriterInterop
        });
        const newAncestors = [];
        if (moveParams && moveParams.newParentPageId && moveParams?.newParentPageId !== 'VIRTUAL_LOCAL_ROOT_ID') {
            const newParentPageId = moveParams?.newParentPageId;
            // Backend only need the direct parent page id in order to move a page
            // Could send the entire ancestor array but decided to keep the request payload small
            newAncestors.push({
                id: newParentPageId
            });
        }
        const newSpaceKey = isBlog || moveParams && moveParams.newParentPageId && moveParams.newParentPageId !== 'VIRTUAL_LOCAL_ROOT_ID' ? moveParams?.newSpaceKey : undefined;
        const notifyWatchers = shouldNotifyOverride ?? shouldNotifyComputedValue;
        onClickPublish({
            suppressNotifyWatchers: !notifyWatchers,
            message: versionComments,
            schedulePublishDate: !!scheduledPublishDate ? scheduledPublishDate?.toISOString() : null,
            ancestors: newAncestors,
            newSpaceKey: newSpaceKey,
            moveRequest: {
                targetId: moveParams?.targetId,
                position: moveParams?.position,
                previousParentPageId: moveParams?.previousParentPageId
            },
            restrictions: hasModifiedRestrictions && gqlRestrictionsInput ? (0, $jVFPV.getRestrictionsForPublish)(gqlRestrictionsInput) : undefined
        })();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'PublishModalPublishButton',
                source: analyticsSource,
                attributes: {
                    notifyWatchers: notifyWatchers,
                    hasModifiedRestrictions: hasModifiedRestrictions,
                    hasNewSpaceKey: moveParams?.newSpaceKey !== undefined && moveParams?.newSpaceKey !== spaceKey,
                    hasNewParentPage: newAncestors.length !== 0,
                    hasComments: !!versionComments,
                    isSchedulePublish: !!scheduledPublishDate,
                    isUnpublishedDraft: !!isUnpublishedDraft
                }
            }
        }).fire();
        isAutoConverted && (0, $cQhbe.sendEditorConversionAnalyticsPageEvent)(createAnalyticsEvent, {
            pageAction: (0, $cQhbe.AutoConvertEvent).PUBLISHED,
            source: analyticsSource
        }, (0, $cQhbe.AutoConvertActionSubject).AUTO_CONVERSION);
    };
    const publishPageAsBlogSuccess = (data)=>{
        const newlyCreatedBlogUrl = data?.confluence_convertToBlogpost?.content?.links?.webui;
        push(`${(0, $jlIaF.CONTEXT_PATH)}${newlyCreatedBlogUrl}`, true);
    };
    const publishPageAsBlogPublishFailure = ({ links: links, errorMessage: errorMessage, flags: callbackFlags })=>{
        // We know what happened, so send an error flag then push the user over to the edit page for
        // the recently converted blog
        (0, $a52bc4dbc0ad9048$export$eaf875eaf4cf65ed)({
            flags: callbackFlags,
            attributes: {
                error: errorMessage
            }
        });
        push(`${(0, $jlIaF.CONTEXT_PATH)}${links?.editui}`, true);
    };
    const conversionFromPageToBlogFailure = (isUnpublishedDraft)=>({ error: error, flags: callbackFlags })=>{
            const errorMessage = `${error?.message || error}`;
            const knownEditorErrorMessage = (0, $dF5uX.knownEditorError)(errorMessage);
            if (knownEditorErrorMessage) (0, $a52bc4dbc0ad9048$export$eaf875eaf4cf65ed)({
                flags: callbackFlags,
                attributes: {
                    error: knownEditorErrorMessage
                },
                customFlagMessage: (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [knownEditorErrorMessage]: true
                    },
                    spaceKey: spaceKey,
                    formatMessage: intl.formatMessage,
                    statusCode: undefined,
                    nextTryIn: 0,
                    isUnpublishedDraft: isUnpublishedDraft
                })
            });
            else (0, $a52bc4dbc0ad9048$export$eaf875eaf4cf65ed)({
                flags: callbackFlags,
                attributes: {
                    error: errorMessage
                }
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        };
    const handlePublishAsBlogClick = async ({ analyticsSource: analyticsSource, isUnpublishedDraft: isUnpublishedDraft })=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'PublishModalPublishAsBlog',
                source: analyticsSource,
                attributes: {
                    notifyWatchers: shouldNotifyComputedValue,
                    hasModifiedRestrictions: hasModifiedRestrictions,
                    hasNewSpaceKey: moveParams?.newSpaceKey !== undefined && moveParams?.newSpaceKey !== spaceKey,
                    hasComments: !!versionComments,
                    isSchedulePublish: !!scheduledPublishDate,
                    isUnpublishedDraft: !!isUnpublishedDraft
                }
            }
        }).fire();
        await convertPageToBlog({
            flags: flags,
            sourceAction: (0, $iVd6X.PublishPageAsBlogSources).EditPage,
            contentId: contentId || '',
            spaceKey: moveParams?.newSpaceKey || spaceKey,
            message: versionComments,
            suppressNotifyWatchers: !shouldNotifyComputedValue,
            schedulePublishDate: scheduledPublishDate?.toISOString(),
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            onConvertAndPublishSucceed: publishPageAsBlogSuccess,
            onPublishFail: publishPageAsBlogPublishFailure,
            onConvertFail: conversionFromPageToBlogFailure(isUnpublishedDraft),
            restrictions: hasModifiedRestrictions && gqlRestrictionsInput ? (0, $jVFPV.getRestrictionsForPublish)(gqlRestrictionsInput) : undefined
        });
    };
    const handlePublish = async ({ analyticsSource: analyticsSource, closeModal: closeModal, isUnpublishedDraft: isUnpublishedDraft, source: source = '', shouldNotifyOverride: shouldNotifyOverride })=>{
        if (publishAsBlog) handlePublishAsBlogClick({
            analyticsSource: analyticsSource,
            isUnpublishedDraft: isUnpublishedDraft
        });
        else {
            if ((0, $9wGTI.fg)('cross-join-3p-nudges-v2')) (0, $9xGvk.runCrossJoinThirdPartyNudgeExperiment)({
                cloudId: cloudId,
                userId: userId,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (source) {
                let trigger = (0, $1C3B1.EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK);
                if (source === 'shortcut') trigger = (0, $1C3B1.EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS);
                (0, $lXYVJ.setViewTransitionSource)(trigger);
            }
            handlePublishWithoutConversion({
                analyticsSource: analyticsSource,
                closeModal: closeModal,
                isUnpublishedDraft: isUnpublishedDraft,
                shouldNotifyOverride: shouldNotifyOverride
            });
        }
        closeModal?.({
            endPublishExperience: true
        });
        closeMove?.();
    };
    const handlePreview = async ({ analyticsSource: analyticsSource, isUnpublishedDraft: isUnpublishedDraft })=>{
        onClickPreview(publishAsBlog, moveParams);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'PublishModalPreviewButton',
                source: analyticsSource,
                attributes: {
                    isUnpublishedDraft: !!isUnpublishedDraft
                }
            }
        }).fire();
        closeMove?.();
    };
    return {
        handlePreview: handlePreview,
        handlePublish: handlePublish
    };
};
module.exports["usePublishModalActions"] = $16359ce789b5f49e$export$d8d8a20fb72e9793;

});

parcelRegister("9xGvk", function(module, exports) {
const $a92c81b97d5786a9$export$36cd22940c76e496 = async (featureVisitedCount, collaboratorsWithJiraAccess, accessCapability)=>{
    const data = {
        featureVisitedCount: featureVisitedCount,
        collaborators: collaboratorsWithJiraAccess.map((c)=>c.id),
        accessCapability: accessCapability
    };
    const response = await fetch('/gateway/api/pi-gateway/webhooks/frontend/confluence/cross-join-third-party-nudge', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return await response.json();
};



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $4f155743195517f7$var$EXPIRY_IN_7_DAYS = 604800;
const $4f155743195517f7$export$262c003deb93a450 = async ()=>{
    try {
        if ($4f155743195517f7$var$getFeatureVisited()) return true;
        $4f155743195517f7$var$snoozeFeatureFor7Days();
        return false;
    } catch (error) {
        return true;
    }
};
const $4f155743195517f7$export$64c6861c3bbd89a2 = ()=>{
    const value = (0, $17wUi.confluenceLocalStorageInstance).getItem($4f155743195517f7$var$getVisitedCountStorageKey());
    return parseInt(value, 10) || 0;
};
const $4f155743195517f7$export$41554dcbb74e65ef = ()=>{
    const currentCount = $4f155743195517f7$export$64c6861c3bbd89a2();
    (0, $17wUi.confluenceLocalStorageInstance).setItem($4f155743195517f7$var$getVisitedCountStorageKey(), currentCount + 1);
};
const $4f155743195517f7$var$snoozeFeatureFor7Days = ()=>{
    $4f155743195517f7$var$setFeatureVisited($4f155743195517f7$var$EXPIRY_IN_7_DAYS);
};
const $4f155743195517f7$var$setFeatureVisited = (expire)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem($4f155743195517f7$var$getVisitedStorageKey(), true, expire);
};
const $4f155743195517f7$var$getFeatureVisited = ()=>(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean($4f155743195517f7$var$getVisitedStorageKey());
function $4f155743195517f7$var$getVisitedStorageKey() {
    return (0, $1UApO.keys).CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_KEY;
}
function $4f155743195517f7$var$getVisitedCountStorageKey() {
    return (0, $1UApO.keys).CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_COUNT;
}


const $f6543ef2747d9a83$export$ff0d532025d54d77 = (createAnalyticsEvent, { attributes: commonAttributes = {} } = {})=>(type, actionSubject, action, actionSubjectId, attributes)=>createAnalyticsEvent({
            type: type,
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                source: 'confluenceCrossJoin3PNudges',
                attributes: {
                    ...commonAttributes,
                    ...attributes
                }
            }
        }).fire();
const $f6543ef2747d9a83$export$16b6aa4401f7ff8f = (analytics, ineligibilityReason)=>{
    const flagKey = 'confluenceCrossJoin3PNudges';
    const action = 'tracked';
    analytics('sendTrackEvent', 'eligibility', action, undefined, {
        flagKey: flagKey,
        ineligibilityReason: ineligibilityReason
    });
};
const $f6543ef2747d9a83$export$ed26b312f8fb3da = (analytics, error)=>analytics('sendOperationalEvent', 'showCrossJoin3PNudges', 'failed', undefined, {
        message: String(error),
        details: {
            ...error || {}
        }
    });


const $63b11f4e84776ff6$export$4f789b4cd8ea4543 = async ({ userId: userId, cloudId: cloudId, collaborators: collaborators, accessCapability: accessCapability, createAnalyticsEvent: createAnalyticsEvent })=>{
    const featureVisitedCount = (0, $4f155743195517f7$export$64c6861c3bbd89a2)();
    const attributes = {
        collaborators: collaborators.length,
        userId: userId,
        cloudId: cloudId,
        featureVisitedCount: featureVisitedCount,
        accessCapability: accessCapability
    };
    const analytics = (0, $f6543ef2747d9a83$export$ff0d532025d54d77)(createAnalyticsEvent, {
        attributes: attributes
    });
    await (0, $a92c81b97d5786a9$export$36cd22940c76e496)(featureVisitedCount, collaborators, accessCapability);
    analytics('sendTrackEvent', 'thirdPartyNudge', 'send', undefined, attributes);
};



const $96ee028cb1a3dd05$export$33030a40c54ad600 = async (product, cloudId)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    const response = await fetch(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const capabilities = (await response.json())?.results[resource];
    return capabilities;
};

const $b591a1cdedd13b67$export$8db0f1e8ecc00a3f = async (cloudId, collaborators)=>{
    const accountIds = collaborators.map((c)=>c.id);
    const response = await fetch('/gateway/api/growth/cross-join-third-party-nudges/get-permitted-users', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            product: 'jira-software',
            accountIds: accountIds
        })
    });
    const returnedAccountIds = await response.json();
    return collaborators.filter((c)=>returnedAccountIds.includes(c.id));
};

const $eb1962aa77f51337$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $eb1962aa77f51337$export$f757fae6e9facd6f = async (integration, cloudId, userId)=>{
    const payload = {
        context: {
            contextType: integration,
            principalId: userId,
            siteId: cloudId
        },
        modelRequestParams: {
            experience: 'CgUserNearbyUser'
        },
        expanded: true,
        maxNumberOfResults: $eb1962aa77f51337$var$COLLABORATION_GRAPH_MAX_RESULTS,
        userId: userId
    };
    const response = await fetch('/gateway/api/collaboration/v1/collaborationgraph/user/user', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const result = (await response.json())?.collaborationGraphEntities?.filter((en)=>en?.userProfile !== undefined && en?.userProfile?.account_type !== 'app' && en?.userProfile?.account_status !== 'deactivated' && en?.userProfile?.account_status !== 'deleted').map(({ userProfile: { account_id: account_id, name: name, picture: picture } })=>({
            id: account_id,
            name: name,
            avatar: picture
        }));
    return result;
};

const $d376976158c415c9$export$780c542cf1b3e229 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await fetch('/gateway/api/permissions/permitted', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return (await response.json()).permitted;
};

const $16b91fa8c9a201a6$export$23b7746c9e6ae406 = async (product, cloudId)=>{
    const traitName = $16b91fa8c9a201a6$var$ACTIVATION_TRAITS[product] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product ${product}`);
    const siteTraits = await $16b91fa8c9a201a6$var$fetchSitePersonalization(cloudId);
    const productActivation = siteTraits.find((trait)=>trait.name === traitName);
    if (productActivation?.value) {
        const oneWeekLaterActivation = new Date(productActivation?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};
const $16b91fa8c9a201a6$var$ACTIVATION_TRAITS = {
    'jira-software': 'jira-software.ondemand.activationDate',
    'jira-product-discovery': 'jira-product-discovery.activationDate'
};
const $16b91fa8c9a201a6$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $16b91fa8c9a201a6$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($16b91fa8c9a201a6$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};



const $74e142e8dfe31baa$export$49a8cf368338c69c = async ({ userId: userId, cloudId: cloudId })=>{
    if (await (0, $d376976158c415c9$export$780c542cf1b3e229)('jira-software', cloudId)) return {
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    const collaborators = await (0, $eb1962aa77f51337$export$f757fae6e9facd6f)('confluenceCrossJoin3PNudges', cloudId, userId);
    if (collaborators === undefined || collaborators.length === 0) return {
        ineligibilityReason: 'NO_COLLABORATORS_FOUND'
    };
    const collaboratorsWithJiraAccess = await (0, $b591a1cdedd13b67$export$8db0f1e8ecc00a3f)(cloudId, collaborators);
    if (collaboratorsWithJiraAccess.length === 0) return {
        ineligibilityReason: 'COLLABORATORS_HAVE_NO_ACCESS'
    };
    const accessCapability = await (0, $96ee028cb1a3dd05$export$33030a40c54ad600)('jira-software', cloudId);
    if (accessCapability !== 'DIRECT_ACCESS' && accessCapability !== 'REQUEST_ACCESS') return {
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    if (!await (0, $16b91fa8c9a201a6$export$23b7746c9e6ae406)('jira-software', cloudId)) return {
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    (0, $4f155743195517f7$export$41554dcbb74e65ef)();
    return {
        ineligibilityReason: null,
        collaborators: collaboratorsWithJiraAccess,
        accessCapability: accessCapability
    };
};



const $b289ca421565d035$export$370e6175b5fe476e = async ({ cloudId: cloudId, userId: userId, createAnalyticsEvent: createAnalyticsEvent })=>{
    const analytics = (0, $f6543ef2747d9a83$export$ff0d532025d54d77)(createAnalyticsEvent);
    try {
        if (!userId || await (0, $4f155743195517f7$export$262c003deb93a450)()) return;
        const response = await (0, $74e142e8dfe31baa$export$49a8cf368338c69c)({
            userId: userId,
            cloudId: cloudId
        });
        if (response.ineligibilityReason !== null) (0, $f6543ef2747d9a83$export$16b6aa4401f7ff8f)(analytics, response.ineligibilityReason);
        else if (response.collaborators !== null) {
            (0, $f6543ef2747d9a83$export$16b6aa4401f7ff8f)(analytics, 'ELIGIBLE');
            await (0, $63b11f4e84776ff6$export$4f789b4cd8ea4543)({
                userId: userId,
                cloudId: cloudId,
                collaborators: response.collaborators,
                accessCapability: response.accessCapability,
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    } catch (error) {
        (0, $f6543ef2747d9a83$export$ed26b312f8fb3da)(analytics, error);
    }
};
module.exports["runCrossJoinThirdPartyNudgeExperiment"] = $b289ca421565d035$export$370e6175b5fe476e;

});


//# sourceMappingURL=PublishButtonWithMoreOptions.271475a8.js.map
